import { ReactComponent as FlagIcon } from "./svg/na-flag.svg";
import "../flag-icon.scss";

export const NAFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
